export default __webpack_public_path__ + "static/media/photo08.9a16a2ab.jpg";